export default __webpack_public_path__ + "static/media/DSC02655 Large.5db67768.jpg";